<template>
  <button class="popup-close-button" @click="closePopup">
    <span class="popup-close-button-box"></span>
  </button>
</template>

<script>
import { POPUP_EVENTS } from '@/shared/ui/popup';

export default {
  props: {
    popupId: {
      type: String,
      required: false,
      default: null,
    },
  },
  methods: {
    closePopup() {
      this.$eventBus.$emit(POPUP_EVENTS.CLOSE, { id: this.popupId, isVisible: false });
    },
  }
};
</script>

<style lang="scss" scoped>
.popup-close-button {
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  position: absolute;
  top: 6px;
  right: 6px;
  z-index: 10;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    opacity: 0.7;
  }

  &-box {
    position: relative;
    width: 12px;
    height: 12px;

    &::before,
    &::after {
      content: '';
      position: absolute;
      width: 12px;
      height: 1.5px;
      background-color: #000000;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%) rotate(45deg);
    }

    &::after {
      transform: translate(-50%, -50%) rotate(-45deg);
    }
  }
}
</style>
